import React from 'react';
import { ProgressiveImage } from '../ProgressiveImage';
import goldPrizeImageSrc from '../../assets/images/prelander/v6/skin-1st.png';
import silverPrizeImageSrc from '../../assets/images/prelander/v6/skin-2nd.png';
import bronzePrizeImageSrc from '../../assets/images/prelander/v6/skin-3rd.png';
import goldPlaceImageSrc from '../../assets/images/prelander/v6/season-winner-1.png';
import silverPlaceImageSrc from '../../assets/images/prelander/v6/season-winner-2.png';
import bronzePlaceImageSrc from '../../assets/images/prelander/v6/season-winner-3.png';
import styles from './SeasonRewardsInformationStage.css';

const PRIZES = [
    {
        id: 1,
        label: 'First place',
        skinName: 'Falchion Knife | Slaughter',
        skinImageUrl: goldPrizeImageSrc,
        color: '#D7B95D',
        placeImageUrl: goldPlaceImageSrc,
    },
    {
        id: 2,
        label: 'Second place',
        skinName: 'Gut Knife | Autotronic',
        skinImageUrl: silverPrizeImageSrc,
        color: '#8F8C9C',
        placeImageUrl: silverPlaceImageSrc
    },
    {
        id: 3,
        label: 'Third place',
        skinName: 'Gut Knife | Bright Water',
        skinImageUrl: bronzePrizeImageSrc,
        color: '#C96A4D',
        placeImageUrl: bronzePlaceImageSrc
    }
];

function SeasonRewardsInformationStage() {
    return (
        <div className={styles.root}>
            <ul className={styles.prizes}>
                {PRIZES.map(prizeItem => (
                    <li
                        className={styles.prizeItem}
                        key={prizeItem.id}
                    >
                        <div className={styles.prizeItemImages}>
                            <ProgressiveImage
                                alt={prizeItem.skinName}
                                src={prizeItem.skinImageUrl}
                                className={styles.skinImage}
                            />
                            <ProgressiveImage
                                alt={prizeItem.label}
                                src={prizeItem.placeImageUrl}
                                className={styles.placeImage}
                            />
                        </div>
                        <div className={styles.prizeItemDescription}>
                            <span
                                className={styles.label}
                                style={{color: prizeItem.color}}
                            >
                                {prizeItem.label}
                            </span>
                            <p className={styles.skinName}>{prizeItem.skinName}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export {
    SeasonRewardsInformationStage
};
